import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Lock, ShieldCheck } from "@phosphor-icons/react";
import { apiClient, setAuthToken } from "../lib/api";
import Header from "../components/Header";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@mauistarpower.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await apiClient.post("/auth/login", { email, password });
      setAuthToken(data.access_token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header variant="default" />
      <div className="pt-20 min-h-screen flex items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <div className="card-clean p-10">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 flex items-center justify-center mb-6">
              <ShieldCheck size={28} weight="duotone" className="text-amber-400" />
            </div>
            <h1 className="font-display text-3xl font-bold text-slate-950">Admin Login</h1>
            <p className="text-slate-500 mt-2">Maui Starpower lead dashboard</p>

            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-clean"
                  data-testid="admin-email-input"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Password</label>
                <div className="relative">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="input-clean pr-10"
                    data-testid="admin-password-input"
                    required
                  />
                  <Lock
                    size={18}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                data-testid="admin-login-submit"
                className="btn-primary w-full justify-center inline-flex disabled:opacity-50"
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
